<template>
    <v-avatar :size="size">
        <img :src="photo.url" v-if="photo != null">
        <img src="@/assets/user-default.jpg" v-else>
    </v-avatar>
</template>

<script>
export default {
    props: ['photo', 'size']
}
</script>
